import styled from '@emotion/styled';
import { DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import { Tag } from '@shared/components/core/text/ContentTypography';

export const DisplayDialogTitle = styled(DialogTitle)`
    flex: 0 1 auto;
    padding: 0;
    margin: 0;
    align-self: center;
    font-weight: 900;
    font-size: 1.75rem; // 28px
    color: ${(props) => props.theme.color.text};
    line-height: 2rem; // 32px
    word-break: break-word;
`;

export const DialogTitleWrap = styled('div')`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-start;
    padding: 1.5rem 1.5rem 0 1.5rem;
    gap: 0.5rem;
`;

export const StyledDialogContent = styled(DialogContent)`
    padding: 0.25rem 1.5rem 1.5rem 1.5rem;
`;

export const DialogChildContentWrapper = styled('div')`
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
    margin-top: 1rem;
`;

export const StyledDialogContentText = styled(DialogContentText)`
    padding: 0.25rem 1.5rem 1.5rem 1.5rem;
`;

export const StyledDialogTag = styled(Tag)`
    word-break: keep-all;
    font-size: 0.875rem;
    line-height: 1.125rem; // 20px
`;
export const StyledDialogActions = styled(DialogActions)`
    padding: 0 1.5rem 1.5rem 1.5rem;
`;
